import apiClient from '@u/apiClient'
import router from '@/router'
import Bugsnag from '@bugsnag/js'
import { helper } from '@u/helper.js'

export default {
  // region login
  login({ commit }, loginData) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .post(`login`, loginData.auth_form, {
          headers: {
            accept: 'application/json',
            'content-type': 'application/json'
          }
        })
        .then((response) => {
          commit('setAuth', {
            auth: response.data.auth,
            expiration: response.data.expiration,
            token: response.data.token
          })
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('expiration', response.data.expiration)
          Bugsnag.leaveBreadcrumb('connection', response.data.auth.full_name)
          Bugsnag.setUser(
            response.data.auth.id,
            response.data.auth.email,
            response.data.auth.full_name
          )
          resolve(response.data)
        })
        .catch((reason) => reject(reason))
    })
  },
  // endregion

  // region logout
  async logout({ commit, dispatch }, payload) {
    await commit('setAuth', { auth: {}, expiration: null, errors: [] })
    dispatch('metadata/resetState', payload, { root: true })
    localStorage.removeItem('token')
    localStorage.removeItem('expiration')
    router.push({ name: 'login' })
  },
  // endregion

  getAuthUser({}) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .get('/auth/user')
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  updateAuthUser: ({ commit, dispatch }, { data, ...rest }) => {
    const formData = helper.toFormData(rest)
    formData.set('data', JSON.stringify(data))

    return new Promise((resolve, reject) => {
      apiClient
        .post(`/auth/user`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region refreshAuth
  async refreshAuth({ commit }) {
    await apiClient
      .get('/auth/user')
      .then((response) => {
        commit('setAuthUser', response.data.user)
        commit('setPermissions')
      })
      .catch((error) => {
        commit('setErrors', error.response)
      })
  },
  // endregion

  // region init pusher
  async initPusher({ commit, state }, payload) {
    apiClient
      .get('/getPusherKey')
      .then(async (response) => {
        payload.successCallback(response.data.key)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  // endregion

  setAuthUser: ({ commit }, payload) => {
    commit('setAuthUser', payload.user)
  },
  setAnimation: ({ commit }, payload) => {
    commit('setAnimation', payload)
  },
  updateUserReleaseNoteVersion({ commit }, version) {
    commit('updateReleaseNoteVersion', version)
  },
  updateGuiSettingsTheme({ commit }, theme) {
    commit('setGuiSettingsTheme', theme)
  }
}
